import React from "react";

/**
 * RivetMark — crisp vector logo mark.
 * Stylized "R" with a mic dot and a checkmark badge, matching the brand identity.
 * Renders sharp at any size (no raster image scaling artifacts).
 */
export function RivetMark({ size = 40, className = "" }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 48 48"
      xmlns="http://www.w3.org/2000/svg"
      className={`shrink-0 ${className}`}
      aria-label="RivetQuote logo"
      data-testid="rivet-logo-mark"
    >
      <defs>
        <linearGradient id="rq-bg" x1="0" y1="0" x2="48" y2="48" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#2563EB" />
          <stop offset="1" stopColor="#001F3F" />
        </linearGradient>
      </defs>
      {/* Rounded square background */}
      <rect x="0" y="0" width="48" height="48" rx="12" fill="url(#rq-bg)" />
      {/* Sky-blue accent stripe (top-left corner) */}
      <path d="M0 12 A12 12 0 0 1 12 0 L18 0 L0 18 Z" fill="#3BB2F6" opacity="0.35" />
      {/* Stylized R glyph */}
      <path
        d="M15 12 L15 36 L20 36 L20 27 L24 27 L29 36 L34.5 36 L28.8 26.3 C31.6 25.1 33.3 22.5 33.3 19.5 C33.3 15.4 30.2 12 26 12 Z M20 16.5 L25.5 16.5 C27.4 16.5 28.7 17.8 28.7 19.7 C28.7 21.6 27.4 22.9 25.5 22.9 L20 22.9 Z"
        fill="#FFFFFF"
      />
      {/* Mic dot (bottom-right) — nods to voice-first */}
      <circle cx="36" cy="34" r="4" fill="#10B981" />
      <path d="M34.5 34 L35.6 35.2 L37.6 33.1" stroke="#FFFFFF" strokeWidth="1.4" fill="none" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export function RivetWordmark({ size = 40, tagline = true }) {
  return (
    <div className="flex items-center gap-3 select-none" data-testid="rivet-logo-wordmark">
      <RivetMark size={size} />
      <div className="flex flex-col leading-none">
        <span
          className="font-black tracking-tight text-[#001F3F]"
          style={{
            fontFamily: "'Cabinet Grotesk', Inter, sans-serif",
            fontSize: Math.round(size * 0.52),
          }}
        >
          Rivet<span className="text-[#2563EB]">Quote</span>
        </span>
        {tagline && (
          <span
            className="uppercase font-semibold text-[#64748B] mt-1"
            style={{
              fontSize: Math.max(9, Math.round(size * 0.24)),
              letterSpacing: "0.22em",
            }}
          >
            Speak. Quote. Done.
          </span>
        )}
      </div>
    </div>
  );
}
